import { render, staticRenderFns } from "./OnlinePackageDet.vue?vue&type=template&id=59426e55&"
import script from "./OnlinePackageDet.vue?vue&type=script&lang=js&"
export * from "./OnlinePackageDet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "OnlinePackageDet.vue"
export default component.exports